module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 02 > Internet Upload.1fe63002.jpg";